import React, { FunctionComponent } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import TextInputField from "../../../Components/TextInput/TextInputField";
import ButtonField from "../../../Components/Button/ButtonField";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import {
  AdminUpdateUserPayload,
  updateUser,
} from "../../../Redux/Slicers/Users/UsersUpdateSlicer";

interface EditUserModalProps {
  user: {
    id: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
  };
  onClose: () => void;
}

const validationSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").nullable(),
});

const EditUserModal: FunctionComponent<EditUserModalProps> = ({
  user,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state.UsersUpdate);

  const formik = useFormik<AdminUpdateUserPayload>({
    initialValues: {
      id: user.id,
      first_name: user.first_name ?? "",
      last_name: user.last_name ?? "",
      email: user.email ?? "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      dispatch(
        updateUser({
          id: values.id,
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email || undefined,
        })
      );
    },
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      style={{ display: "flex", flexDirection: "column", gap: 16 }}
    >
      <TextInputField
        name="phone"
        label="Phone (not editable)"
        value={user.phone ?? ""}
        onChange={() => {}}
        disabled
      />
      <TextInputField
        name="first_name"
        label="First name"
        value={formik.values.first_name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.first_name && Boolean(formik.errors.first_name)}
        helperText={
          formik.touched.first_name && (formik.errors.first_name as string)
        }
      />
      <TextInputField
        name="last_name"
        label="Last name"
        value={formik.values.last_name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.last_name && Boolean(formik.errors.last_name)}
        helperText={
          formik.touched.last_name && (formik.errors.last_name as string)
        }
      />
      <TextInputField
        name="email"
        label="Email"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.email && Boolean(formik.errors.email)}
        helperText={formik.touched.email && (formik.errors.email as string)}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <ButtonField className="cancel_button" type="button" onClick={onClose}>
          Cancel
        </ButtonField>
        <ButtonField
          className="add_button"
          type="submit"
          disabled={!!isLoading}
        >
          {isLoading ? "Saving..." : "Save"}
        </ButtonField>
      </div>
    </form>
  );
};

export default EditUserModal;
